export default "__VITE_ASSET__QaRt2JVy__"